import { getFavoriteChannelsQueryData } from './queries';

export function getFavoriteChannels(): Map<number, number> | undefined {
  return getFavoriteChannelsQueryData()?.favoritePositions;
}
